<template>
  <span style="padding: 0">
    <el-input-number
      @blur="handleBlur"
      :value="value"
      :disabled="disabled"
      :controls="false"
      size="small"
      :min="1"
    ></el-input-number>
  </span>
</template>

<script>
export default {
  props: ["value", "disabled"],
  computed: {},
  data() {
    return {};
  },
  methods: {
    handleBlur(e) {
      e.target.value
        ? (e.target.value = parseInt(e.target.value))
        : (e.target.value = "1"); // 小数取整
      this.$emit("input", e.target.value);
    },
  },
};
</script>

<style>
</style>